// extracted by css-extract-rspack-plugin
export default {"root":"_FwhUFxvSU1ml4of","actions":"GkKpipSrA4MBbGWI","blockActions":"Tw4Je76PMYAz05_g","inlineBlock":"OWgqmnLKwU0166FL","messageTimestamp":"ZR1eVdDq5DgJm34I"};